// extracted by mini-css-extract-plugin
export default {"header":"Header_header__pLhA1","logo":"Header_logo__MQnNN","content":"Header_content__qF+kc","company":"Header_company__ibk3i"};